var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 26,
    viewBox: "0 0 13 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.30656 5.33125V8.76625H0.789062V12.9662H3.30656V25.4487H8.47406V12.9675H11.9428C11.9428 12.9675 12.2678 10.9537 12.4253 8.75125H8.49531V5.87875C8.49531 5.45 9.05781 4.8725 9.61531 4.8725H12.4328V0.5H8.60281C3.17781 0.5 3.30656 4.70375 3.30656 5.33125Z",
    fill: "#3D5A98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.f6710e0e305ceaa8f2cd44ccc9315489.svg";
export { ForwardRef as ReactComponent };